import React from "react";
import { faLock, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import Helmet from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { AppLogo, Button } from "../../components";
import { TextField } from "../../components/fields";
import { useAuthentication, useStateReducer } from "../../hooks";
import { classNameBuilder } from "../../utilities";
import { global } from "../../_config";
import "./_styles.scss";
import { hideAlert, showAlert } from "../../components/alert/Alert";

export default function LoginPage() {
  const navigate = useNavigate();
  const [state, setState] = useStateReducer({
    username: "",
    password: "",
    submitting: false,
    error: false,
    loading: true,
  });
  const auth = useAuthentication();

  const handleChange = (prop: string, value: any) =>
    setState({ [prop]: value, errorHightlight: false });

  const handleSignIn = async () => {
    const res = await auth?.signIn(state.username, state.password);
    if (res && res.id && res.userStatus === "Accepted") {
      navigate("/home", { replace: true });
    } else {
      setState({ error: true, errorHightlight: true, password: "" });
      let message = "Invalid username or password entered. Please try again.";
      if (res && res.id && res.userStatus === "Pending")
        message = "Your access is pending. We will notify you once accepted.";
      showAlert({
        content: message,
        options: { actions: [{ text: "Ok", onClick: hideAlert }] },
      });
      setTimeout(() => setState({ error: false }), 1000);
    }

    setState({ submitting: false });
  };

  const checkForSubmit = (e: any) => {
    if (e.key === "Enter") {
      handleSignIn();
      setState({ submitting: true });
    }
  };

  useEffect(() => {
    if (!auth?.user)
      setTimeout(() => {
        setState({ loading: false });
      }, 1100);
  }, [setState, auth]);

  if (auth?.user) {
    navigate("/");
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Sign In - {global.applicationName}</title>
      </Helmet>
      <div
        className={classNameBuilder(
          "h-app-login",
          state.loading ? "in" : "",
          state.error ? "error" : "",
          state.errorHightlight ? "error-highlight" : ""
        )}
      >
        <AppLogo />
        <div className="credentials">
          <TextField
            focus={!state.username}
            startAdornment={<FontAwesomeIcon icon={faUser} />}
            placeholder="Email Address"
            value={state.username}
            onChange={(e: any) => handleChange("username", e.target.value)}
            onKeyDown={checkForSubmit}
          />
          <TextField
            focus={state.error}
            type="password"
            placeholder="Password"
            startAdornment={<FontAwesomeIcon icon={faLock} />}
            value={state.password}
            onChange={(e: any) => handleChange("password", e.target.value)}
            onKeyDown={checkForSubmit}
          />
        </div>
        <div className="button-container">
          <Link to={"/forgotpassword"}>Forgot Password?</Link>
          <Link to={"/register"}>Register</Link>
          <Button
            text="Sign In"
            primary
            raised
            onClick={handleSignIn}
            working={state.submitting}
          />
        </div>
      </div>
    </>
  );
}
